<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style">
            <div class="content mt-3">
				<div class="tabs tabs-box" id="tab-mode-surah">
					<div class="tab-controls rounded-s border-highlight">
						<a @click.prevent="setActive('quran')" :aria-expanded="isActive('quran')" class="font-13 color-highlight" href="#">Quran</a>
						<a @click.prevent="setActive('khazanah')" :aria-expanded="isActive('khazanah')" class="font-13 color-highlight" href="#">Khazanah</a>
					</div>

					<div class="mt-3"></div>

					<div class="collapse" :class="{ 'show': isActive('quran') }">

                        <div class="card card-style">
                            <div class="content mb-0">
                                <h6 class="text-uppercase mt-n2">Daftar Surat Bookmark</h6>
                                <div class="list-group list-custom list-group-m list-group-flush rounded-xs check-visited">
                                    <div v-for="(surah_bookmark, index) in quranSurahBookmark" :key="index" class="list-group-item">
                                        <i class="has-bg rounded-s bi gradient-highlight">{{ surah_bookmark.surah.no }}</i>
                                        <div>{{ surah_bookmark.surah.name }} <span>(Halaman : {{ surah_bookmark.page.join(", ") }})</span> </div>
                                        <!-- <i class="bi bi-chevron-right"></i> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

					<div class="collapse" :class="{ 'show': isActive('khazanah') }">

                        <div class="card card-style">
                            <div class="content mb-0">
                                <h6 class="text-uppercase mt-n2">Daftar Khazanah Bookmark</h6>
                                <div class="list-group list-custom list-group-m list-group-flush rounded-xs check-visited">
                                    <div v-for="(khazanah_bookmark, index) in khazanahBookmark" :key="index" class="list-group-item">
                                        <i class="has-bg rounded-s bi gradient-highlight"></i>
                                        <div>{{ khazanah_bookmark.title }} <span>(Halaman : {{ khazanah_bookmark.page.join(", ") }})</span> </div>
                                        <!-- <i class="bi bi-chevron-right"></i> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

				</div>
			</div>

        </div>

        <!-- <div class="d-flex justify-content-evenly py-2 paggination">
            <i v-if="prev_page_url" @click="PagginationSurah('prev')" class="bi bi-arrow-left-square-fill fs-5"></i>
            <div class="d-flex align-items-center">
                <h4>Halaman : {{ page }}</h4>
                <a href="#" v-if="$store.state.token" class="ms-2 icon icon-xxs border-highlight border color-highlight rounded-xs me-2"><i class="bi bi-bookmark"></i></a>
            </div>
            <i v-if="next_page_url" @click="PagginationSurah('next')" class="bi bi-arrow-right-square-fill fs-5"></i>
        </div> -->

    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'Bookmarak',
    data(){
        return {
            activeTab: 'quran'
        }
    },
    created() {
       this.getQuranSurahBookmark()
       this.getKhazanahBookmark()
    },
    methods: {
        ...mapActions('bookmark', ['getQuranSurahBookmark', 'getKhazanahBookmark']),
        isActive (menuItem) {
            return this.activeTab === menuItem
        },
        setActive (menuItem) {
            this.activeTab = menuItem
        }
    },
    computed: {
        ...mapState('bookmark', {
            quranSurahBookmark: state => state.quranSurahBookmark,
            khazanahBookmark: state => state.khazanahBookmark
        })
    }
}
</script>

<style scoped>
.page-content {
  padding-bottom: 146px;
}

.paggination {
    position: fixed;
    bottom: 60px;
    /* width: 100%; */
    right: 0;
    left: 0;
    background-color: white;
    border: 1px solid #cecece;
}
.paggination-detached {
    left: 10px !important;
    right: 10px !important;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 25px;
}
</style>
